"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategorizeChoiceContent = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("../../../../Button");
const ControlSeparator_1 = require("../../../ControlSeparator");
const StackView_1 = require("../../../../StackView");
const constants_1 = require("../../helpers/constants");
const CategorizeChoiceItems_1 = require("../CategorizeChoiceItems/CategorizeChoiceItems");
exports.CategorizeChoiceContent = react_1.default.memo(function CategorizeChoiceContent({ groups, canSelectAll, canClearAll, onSelectAll, onClearAll, onToggleItem, isSelected, texts }) {
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column },
        react_1.default.createElement(CategorizeChoiceItems_1.CategorizeChoiceItems, { groups: groups, onToggleItem: onToggleItem, isSelected: isSelected }),
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.center },
            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, disabled: !canSelectAll, onClick: onSelectAll, "data-selector-id": constants_1.dataSelectorId.selectAll }, texts.selectAll),
            react_1.default.createElement(ControlSeparator_1.ControlSeparator, null),
            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, disabled: !canClearAll, onClick: onClearAll, "data-selector-id": constants_1.dataSelectorId.clearAll }, texts.clearAll))));
});
//# sourceMappingURL=CategorizeChoiceContent.js.map